module.exports = __webpack_public_path__ + "static/media/error.f0645665.svg";